import http from '@/http';

export default {
    list() {
        return http.get('/demand-owner-substitutions');
    },
    fetch(id) {
        return http.get(`/demand-owner-substitutions/${id}`);
    },
    remove(id) {
        return http.delete(`/demand-owner-substitutions/${id}`);
    },
    save(form) {
        return http.post('/demand-owner-substitutions', form);
    },
    update(id, form) {
        return http.put(`/demand-owner-substitutions/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/demandOwnerSubstitutions.js